import { UserData } from '@wwe-portal/entities/user.type';
import { getDefaultMeta, sendGameTransactionEvent } from './common';
import { v4 as uuidv4 } from 'uuid';
import { sendGTMEvent } from './gtm-helper';

export const sendTriviaGameEvent = () => {
  sendGTMEvent({
    category: 'Trivia Game',
    event: 'trivia_game_start',
    action: 'trivia-game/started',
  });
};

export const sendTriviaGameStartEvent = ({
  currentUser,
  energyCost,
}: {
  currentUser: UserData;
  energyCost: number | undefined;
}) => {
  sendTriviaGameEvent();

  const transactionId = uuidv4();

  const { sys_user_id, sys_platform, sys_os_s, reference_id } =
    getDefaultMeta();

  const initialParameters = {
    sys_user_id,
    sys_platform,
    sys_os_s,
    currentUser,
    event_source: 'web_portal',
    trans_type: 'web_currency_spend',
    transaction_type: 'spend',
    reference_id,
  };

  sendGameTransactionEvent({
    ...initialParameters,
    trans_desc: 'play_trivia',
    trans_type: 'web_currency_spend',
    context: 'q1',
    reference_id: 'trivia_rumble',
    sys_platform: 'web',
    transaction_id: transactionId,
    sys_user_id: currentUser?.userId || null,
    item_id: 'web_currency_energy',
    item_name: 'energy',
    quantity: -Number(energyCost),
    item_balance: currentUser.energy,
    reference_subtype_3: 'trivia_rumble',
  });
};

export const sendTriviaGameWonEvent = ({
  currentUser,
  reward,
}: {
  currentUser: UserData;
  reward: number | undefined;
}) => {
  const transactionId = uuidv4();

  const { sys_user_id, sys_platform, sys_os_s, reference_id } =
    getDefaultMeta();

  const initialParameters = {
    sys_user_id,
    sys_platform,
    sys_os_s,
    currentUser,
    event_source: 'web_portal',
    trans_type: 'web_currency_spend',
    transaction_type: 'earn',
    reference_id,
  };

  sendGameTransactionEvent({
    ...initialParameters,
    trans_type: 'web_currency_spend',
    trans_desc: 'earn_trivia_reward',
    context: `q5`,
    reference_id: 'trivia_rumble',
    event_source: 'web_portal',
    sys_platform: 'web',
    transaction_id: transactionId,
    sys_user_id: currentUser?.userId || null,
    item_id: 'web_currency_web_coin',
    item_name: 'web_coin',
    quantity: +(reward ?? 0),
    item_balance: currentUser.webCoin,
    reference_subtype_3: 'trivia_rumble',
  });
};

export const sendTriviaGamePlayAgainEvent = ({
  currentUser,
  energyCost,
}: {
  currentUser: UserData;
  energyCost: number | undefined;
}) => {
  const transactionId = uuidv4();

  const { sys_user_id, sys_platform, sys_os_s, reference_id } =
    getDefaultMeta();

  const initialParameters = {
    sys_user_id,
    sys_platform,
    sys_os_s,
    currentUser,
    event_source: 'web_portal',
    trans_type: 'web_currency_spend',
    transaction_type: 'spend',
    reference_id,
  };

  sendGameTransactionEvent({
    ...initialParameters,
    trans_type: 'web_currency_spend',
    trans_desc: 'play_trivia',
    context: 'q1',
    reference_id: 'trivia_rumble',
    event_source: 'web_portal',
    sys_platform: 'web',
    transaction_id: transactionId,
    sys_user_id: currentUser?.userId || null,
    player_name: currentUser?.nickname || currentUser?.temporaryNickname || '',
    item_id: 'web_currency_energy',
    item_name: 'energy',
    quantity: -Number(energyCost),
    item_balance: currentUser.energy,
    reference_subtype_3: 'trivia_rumble',
  });
};

export const sendTriviaGameContinueEvent = ({
  currentUser,
  neededWebCoin,
  questionStep,
}: {
  currentUser: UserData;
  neededWebCoin: number | undefined;
  questionStep: number | undefined;
}) => {
  const transactionId = uuidv4();

  const { sys_user_id, sys_platform, sys_os_s, reference_id } =
    getDefaultMeta();

  const initialParameters = {
    sys_user_id,
    sys_platform,
    sys_os_s,
    currentUser,
    event_source: 'web_portal',
    trans_type: 'web_currency_spend',
    transaction_type: 'earn',
    reference_id,
  };

  sendGameTransactionEvent({
    ...initialParameters,
    trans_type: 'web_currency_spend',
    trans_desc: 'retry_trivia',
    context: `q${questionStep}`,
    reference_id: 'trivia_rumble',
    event_source: 'web_portal',
    sys_platform: 'web',
    transaction_id: transactionId,
    sys_user_id: currentUser?.userId || null,
    item_id: 'web_currency_web_coin',
    item_name: 'web_coin',
    quantity: -Number(neededWebCoin),
    item_balance: currentUser.webCoin,
    reference_subtype_3: 'trivia_rumble',
  });
};
